module.exports = __webpack_public_path__ + "static/media/testimonio2.e9cbe2c0.jpg";